import {createContext} from "react";
import {OldCommonOrgEntity} from "../model";
import {OldCommonOrgEntityContextValue} from "./OldCommonOrgEntityContextValue";

export const OldCommonOrgEntityContext =
  createContext<OldCommonOrgEntityContextValue>({
    entity: {} as OldCommonOrgEntity
  });
